import React from 'react'

import PageContent from '../../components/PageContent'
import PageHeader from '../../components/PageHeader'

import { TaskBoard } from '../../applets/TaskBoard'

import { LangContext } from '../../components/Translation'
import translations from './translations'

export default function Tasks() {
	const lang = React.useContext(LangContext)(translations)

	return (
		<PageHeader title={lang('title')}>
			<PageContent>
				<div className="container-xl">
					<div className="row row-deck row-cards">
						<div className="col-12">
							<TaskBoard title={lang('tasks')} userTasks={false} />
						</div>
					</div>
				</div>
			</PageContent>
		</PageHeader>
	)
}
